/* eslint-disable no-irregular-whitespace */
const data = {
  category: {
    deals: {
      PHD: (categoryId) => ({
        en: `/en/deals/${categoryId}`,
        ar: `/ar/العروض/${categoryId}`,
      }),
    },
    pizza: {
      PHD: (categoryId) => ({
        en: `/en/pizza/${categoryId}`,
        ar: `/ar/البيتزا/${categoryId}`,
      }),
    },
    'for-me': {
      PHD: (categoryId) => ({
        en: `/en/for-me/${categoryId}`,
        ar: `/ar/لي-وحدي/${categoryId}`,
      }),
    },
    pasta: {
      PHD: (categoryId) => ({
        en: `/en/pasta/${categoryId}`,
        ar: `/ar/الباستا/${categoryId}`,
      }),
    },
    starters: {
      PHD: (categoryId) => ({
        en: `/en/starters/${categoryId}`,
        ar: `/ar/المقبلات/${categoryId}`,
      }),
    },
    wingstreet: {
      PHD: (categoryId) => ({
        en: `/en/wingstreet/${categoryId}`,
        ar: `/ar/وينج-ستريت/${categoryId}`,
      }),
    },
    desserts: {
      PHD: (categoryId) => ({
        en: `/en/desserts/${categoryId}`,
        ar: `/ar/الحلويات/${categoryId}`,
      }),
    },
    drinks: {
      PHD: (categoryId) => ({
        en: `/en/drinks/${categoryId}`,
        ar: `/ar/المشروبات/${categoryId}`,
      }),
    },
    melts: {
      PHD: (categoryId) => ({
        en: `/en/melts/${categoryId}`,
        ar: `/ar/ميلتس/${categoryId}`,
      }),
    },
    'build-your-own-pizza': {
      PHD: (categoryId) => ({
        en: `/en/build-your-own-pizza/${categoryId}`,
        ar: `/ar/بناء-بنفسك/${categoryId}`,
      }),
    },
    'build-your-own': {
      PHD: (categoryId) => ({
        en: `/en/build-your-own/${categoryId}`,
        ar: `/ar/بناء-بنفسك/${categoryId}`,
      }),
    },
    'limited-time-offer': {
      PHD: (categoryId) => ({
        en: `/en/limited-time-offer/${categoryId}`,
        ar: `/ar/عرض-لمدة-محدودة/${categoryId}`,
      }),
    },
    'my-favorites': {
      PHD: (categoryId) => ({
        en: `/en/my-favorites/${categoryId}`,
        ar: `/ar/my-favorites/${categoryId}`,
      }),
    },
    extras: {
      PHD: (categoryId) => ({
        en: `/en/extras/${categoryId}`,
        ar: `/ar/إضافات/${categoryId}`,
      }),
    },
    'champions-deal': {
      PHD: (categoryId) => ({
        en: `/en/champions-deal/${categoryId}`,
        ar: `/ar/عرض-الأبطال/${categoryId}`,
      }),
    },
    'ramadan-meals': {
      PHD: (categoryId) => ({
        en: `/en/ramadan-meals/${categoryId}`,
        ar: `/ar/عروض-يوم-المباراة/${categoryId}`,
      }),
    },
  },
};

export default data;
